
import React from 'react';

const NotificationsIcon = (props) => {

  let { 
    height, 
    width, 
    iconColor,
  } = props;

  return (
    <svg 
      width={width ? width : '20px'} 
      height={height ? height : '19px'} 
      viewBox="0 0 20 19" 
      version="1.1" 
      xmlns="http://www.w3.org/2000/svg" 
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>Notifications</title>
      <g id="V.4-Design-Change" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="company-filter--copy-2" transform="translate(-1149.000000, -31.000000)" fillRule="nonzero" fill={iconColor}>
          <path d="M1168,46.2 C1167.0044,46.2 1165.6896,44.68 1165.6896,43.7908 L1165.6896,39.5956 C1165.6896,36.51 
            1163.4552,33.6676 1160.3848,32.8392 C1160.3772,32.8392 1160.362,32.8316 1160.3544,32.8316 C1160.2708,31.7752 
            1159.4956,31 1158.4696,31 C1157.4588,31 1156.6912,31.7524 1156.5924,32.7784 C1156.5848,32.7784 1156.5696,32.7784 
            1156.562,32.786 C1153.4384,33.6296 1151.2496,36.3732 1151.2496,39.4588 L1151.2496,43.7908 C1151.2496,44.5432 
            1150.6796,46.2 1149,46.2 L1149,46.96 L1155.1256,46.96 C1155.2928,48.6624 1156.7216,50 1158.4696,50 C1160.2176,50 
            1161.6388,48.6624 1161.8136,46.96 L1168.0076,46.96 L1168.0076,46.2 L1168,46.2 Z M1158.4696,31.76 C1159.0092,31.76 
            1159.4272,32.1172 1159.564,32.6416 C1159.222,32.5808 1158.8572,32.5276 1158.4696,32.5276 C1158.0896,32.5276 
            1157.7324,32.558 1157.3828,32.6112 C1157.5272,32.102 1157.9376,31.76 1158.4696,31.76 Z M1158.4696,49.24 
            C1157.1548,49.24 1156.0756,48.252 1155.8932,46.9524 L1161.0536,46.9524 C1160.8864,48.2368 1159.7996,49.24 
            1158.4696,49.24 Z M1150.9608,46.2 C1151.6676,45.5312 1152.0096,44.5508 1152.0096,43.7908 L1152.0096,39.4588 
            C1152.0096,36.7152 1153.9628,34.2756 1156.7596,33.5156 C1157.2992,33.3636 1157.854,33.2952 1158.4696,33.2952 
            C1159.108,33.2952 1159.716,33.4396 1160.1796,33.5764 C1162.9308,34.3212 1164.9296,36.852 1164.9296,39.6032 
            L1164.9296,43.7984 C1164.9296,44.5584 1165.5072,45.5388 1166.2824,46.2076 L1150.9608,46.2076 L1150.9608,46.2 Z" 
            id="Notification"></path>
        </g>
      </g>
    </svg>
  );
};

export default NotificationsIcon;



// WEBPACK FOOTER //
// ./src/components/Iconoclast/NotificationsIcon/index.js